import { StoreCode } from 'schema/storeCode';
import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem
} from 'state/localStorage/index';

function getKey(store: StoreCode) {
  return `ag-checkout-${store}`;
}

export function getCheckoutToken(store: StoreCode) {
  const token = getLocalStorageItem(getKey(store));

  return typeof token === 'string' ? token : null;
}

export function setCheckoutToken(store: StoreCode, token: string) {
  const key = getKey(store);
  setLocalStorageItem(key, token);
}

export function clearCheckoutToken(store: StoreCode) {
  const key = getKey(store);
  removeLocalStorageItem(key);
}
